import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {UserEvent} from 'yougile-model'
import {formatTime} from './get-action-name-change-stopwatch'

export const getActionNameChangeTimer = (event: UserEvent): string => {
  if (event.type !== 'timer') {
    return ''
  }

  const {options} = event
  if (!options) {
    return ''
  }

  const oldValue = options?.oldValue
  const newValue = options?.newValue

  if (oldValue && !newValue) {
    return Lang.msg.statsTimeline.statActionTimerDetached
  }

  if (!oldValue && newValue) {
    const time = formatTime(newValue)
    return Lang.msg.statsTimeline.statActionTimerInited(time)
  }

  if (!oldValue?.running && newValue?.running) {
    const time = formatTime(newValue)
    return Lang.msg.statsTimeline.statActionTimerSet(time)
  }

  if (oldValue?.running && !newValue?.running) {
    const time = formatTime(newValue)
    return Lang.msg.statsTimeline.statActionTimerStop(time)
  }

  if (oldValue?.time !== newValue?.time) {
    const prev = formatTime(oldValue)
    const curr = formatTime(newValue)
    return Lang.msg.statsTimeline.statActionTimerChanged(prev, curr)
  }

  logger.warn('event', JSON.stringify(event, null, ' '))

  return 'Error'
}
